export default __webpack_public_path__ + "static/media/manufacturing.cf4bc49f.jpg";